import React from 'react';
import { StoreDetailProps } from 'util/Props';
import { parseNumber, formatNumber } from 'libphonenumber-js';

import config from 'config';
import i18n from 'i18n/en.json';
/**
    Store details should be used anytime brief store information is displayed on the page, including address,
    my store indicator and make an appointment CTA.
*/
class StoreDetailsBase extends React.Component {
    constructor(props) {
        super(props);
        this.getDirections = this.getDirections.bind(this);
        this.handleMystoreAction = this.handleMystoreAction.bind(this);
        this.roundDistance = this.roundDistance.bind(this);
        this.formatPhone = this.formatPhone.bind(this);
        this.setUserLocation = this.setUserLocation.bind(this);

        this.state = {
            userLocation: null //TODO: normalize location object and hook up props
        };
    }

    // Return formatted address
    formatAddress(address) {
        if(address) {
            return `${address[0]}, ${address.slice(1).join(' ')}`
        }
    }

    // keeps geolocation in localStorage
    setUserLocation() {
        try {
            let coords = JSON.parse(localStorage.getItem('coords'));

            if (!coords) {
                navigator.geolocation.getCurrentPosition(
                    pos => {
                        coords = {
                            uLat: pos.coords.latitude,
                            uLng: pos.coords.longitude
                        };
                        this.setState({ userLocation: coords });
                        localStorage.setItem('coords', JSON.stringify(coords));
                    },
                    err => {
                        console.log(err);
                    }
                );
            } else {
                this.setState({ userLocation: coords });
            }
        } catch (e) {
            console.log(e.message);
        }
    }

    //result: 10.0mi
    roundDistance(num) {
        return Number.parseFloat(num).toFixed(1);
    }
    //format comes in as just a string of numbers ex 5555551234
    formatPhone() {
        return this.props.phone.length > 1
            ? formatNumber(parseNumber(this.props.phone, 'US'), 'National')
            : i18n.openingSoon;
    }
    componentDidMount() {
        if ('geolocation' in navigator) {
            this.setUserLocation();
        }
        if (this.props.handleMount) {
            this.props.handleMount({
                index: !isNaN(this.props.index) ? this.props.index : null,
                id: this.props.id,
                latitude: this.props.latitude,
                longitude: this.props.longitude,
                address: this.props.address1,
                isMystore: this.props.isMystore,
                isSelectedStore: this.props.isSelectedStore,
                distance: this.props.distance,
                enableAppointment: this.props.enableAppointment
            });
        }
    }
    handleMystoreAction(event) {
        const target = event.target;
        if (target.checked && !this.isMystore) {
            this.props.postMyStore(
                this.props.makeMyStoreUrl,
                this.props.id,
                false,
                this.props.isAppointment,
                this.props.isDialog
            );
        }
    }
    //returns URL for the directions button
    getDirections() {
        let params = [
            'api=1',
            `origin=${
                this.state.userLocation
                    ? this.state.userLocation.uLat + ',' + this.state.userLocation.uLng
                    : ''
            }`,
            `destination=${this.props.address1},${this.props.city},${this.props.stateCode},${this.props.postalCode}`
        ];

        return `${config.googleMaps.url}?` + encodeURI(params.join('&'));
    }
    //this is abstract
    render() {
        return null;
    }
}

StoreDetailsBase.propTypes = StoreDetailProps;

export default StoreDetailsBase;
